namespace RioERP.Products {
    export interface ProductSpecificationsRow {
        Id?: number;
        SpecificationName?: string;
        ProductId?: number;
        SpecificationCode?: number;
        HasBooks?: boolean;
        HasPendrive?: boolean;
        IsLive?: boolean;
        IsTemplateSerialKey?: boolean;
        ProcessOrderOnPaid?: boolean;
        Eopens?: Web.Enums.EOpens;
        EWatchtime?: Web.Enums.EWatchTime;
        EValidityType?: Web.Enums.EValidityType;
        EValidity?: Web.Enums.EValidity;
        ValidTill?: string;
        AllowedDevices?: string;
        AllowedDevice?: number[];
        HasCourier?: boolean;
        ProductSpecificationBookId?: number[];
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        Rioplay8ESubscriptionType?: Web.Enums.ESubscriptionType;
        Rioplay8EViewsType?: Rio.Enums.EViewType;
        Rioplay8EWatchTimetype?: Rio.Enums.EWatchTimetype;
        Rioplay8ViewsPerContent?: number;
        Rioplay8WatchTime?: number;
        Rioplay8AllowedDevices?: string;
        Rioplay8ValidityInDays?: number;
        Rioplay8ValidDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductSpecificationsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SpecificationName';
        export const localTextPrefix = 'Products.ProductSpecifications';
        export const lookupKey = 'Products.ProductSpecifications';

        export function getLookup(): Q.Lookup<ProductSpecificationsRow> {
            return Q.getLookup<ProductSpecificationsRow>('Products.ProductSpecifications');
        }
        export const deletePermission = 'Products:ProductsManagement:Modify';
        export const insertPermission = 'Products:ProductsManagement:Modify';
        export const readPermission = 'Products:ProductsManagement:View';
        export const updatePermission = 'Products:ProductsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            SpecificationName = "SpecificationName",
            ProductId = "ProductId",
            SpecificationCode = "SpecificationCode",
            HasBooks = "HasBooks",
            HasPendrive = "HasPendrive",
            IsLive = "IsLive",
            IsTemplateSerialKey = "IsTemplateSerialKey",
            ProcessOrderOnPaid = "ProcessOrderOnPaid",
            Eopens = "Eopens",
            EWatchtime = "EWatchtime",
            EValidityType = "EValidityType",
            EValidity = "EValidity",
            ValidTill = "ValidTill",
            AllowedDevices = "AllowedDevices",
            AllowedDevice = "AllowedDevice",
            HasCourier = "HasCourier",
            ProductSpecificationBookId = "ProductSpecificationBookId",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            Rioplay8ESubscriptionType = "Rioplay8ESubscriptionType",
            Rioplay8EViewsType = "Rioplay8EViewsType",
            Rioplay8EWatchTimetype = "Rioplay8EWatchTimetype",
            Rioplay8ViewsPerContent = "Rioplay8ViewsPerContent",
            Rioplay8WatchTime = "Rioplay8WatchTime",
            Rioplay8AllowedDevices = "Rioplay8AllowedDevices",
            Rioplay8ValidityInDays = "Rioplay8ValidityInDays",
            Rioplay8ValidDate = "Rioplay8ValidDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
